var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgView = function SvgView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".view_svg__cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), /*#__PURE__*/React.createElement("g", {
    id: "view_svg__Group_21554",
    "data-name": "Group 21554",
    transform: "translate(-892 -804)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "view_svg__Group_21551",
    "data-name": "Group 21551",
    transform: "translate(894 808.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "view_svg__Path_17743",
    "data-name": "Path 17743",
    className: "view_svg__cls-1",
    d: "M13.5 11.25A2.25 2.25 0 1 1 11.25 9a2.25 2.25 0 0 1 2.25 2.25Z",
    transform: "translate(-4.094 -6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "view_svg__Path_17744",
    "data-name": "Path 17744",
    className: "view_svg__cls-1",
    d: "M2.458 10.25a7.5 7.5 0 0 1 14.313 0 7.5 7.5 0 0 1-14.313 0Z",
    transform: "translate(-2.458 -5.25)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "view_svg__Rectangle_19851",
    "data-name": "Rectangle 19851",
    transform: "translate(892 804)",
    style: {
      fill: "none"
    },
    d: "M0 0h18v18H0z"
  })));
};

export default SvgView;